import React, { Children, cloneElement, isValidElement, useCallback, useState } from 'react';
import { Dialog } from "../../../dialog/Dialog.js";
import styles from "./MultiSelectMobileModal.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const MultiSelectMobileModal = ({
  onClose,
  label,
  children,
  submitButtonCaption,
  activeItems,
  onSubmit,
  id
}) => {
  const [items, setItems] = useState(activeItems);
  const addItem = useCallback(item => {
    setItems(items => [...items, item]);
  }, [setItems]);
  const removeItem = useCallback(item => {
    setItems(items => items.filter(value => value !== item));
  }, [setItems]);
  const _children = Children.map(children, (child, index) => {
    if (! /*#__PURE__*/isValidElement(child)) {
      return null;
    }
    // omit `label`-property, because cloneElement merges props
    const props = {
      ...child.props,
      onChange: checked => {
        if (checked) {
          addItem(child.props.value);
        } else {
          removeItem(child.props.value);
        }
      },
      mobile: true,
      active: items.includes(child.props.value)
    };
    return /*#__PURE__*/cloneElement(child, props);
  });
  return /*#__PURE__*/_jsx(Dialog, {
    id: `${id}-modal`,
    title: label,
    onCancel: onClose,
    onConfirm: () => onSubmit(items),
    confirmButtonCaption: submitButtonCaption,
    className: styles.dialog,
    children: _children
  });
};